module.exports = __webpack_public_path__ + "img/icon-tick.80992ccb.svg";